export enum SearchResultType {
    Site = 1,
    Person,
    Company,
    Team,
    Equipment,
    Something = 98,
    NoResultsFound = 99,
}
